// const fetchEntity = require("./fetchEntity");
const fetchAs = require("./fetchAs");
const findImage = require("./findImage");
const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

/**
 * Fetch image attributes from a media relationship data
 * @param rel: object with id: uuid and type: media--bundle
 */
module.exports = async function fetchImage(rel, authContext) {
	let type = rel.type.split("--");
	let endpoint = `${type[0]}/${type[1]}/${rel.id}`;
	let _image = await fetchAs({ endpoint, authContext });
	if (_image && _image.data && _image.data.attributes) {
		if (_image.data.type === "media--video_stream") {
			let src;
			let cloudflare = _image.data.attributes.field_video_id;
			let image = {
				alt: "",
				title: null,
				width: 640,
				height: 340,
				caption: null,
				cloudflare,
			};

			if (_image.data.relationships.field_media_image.data) {
				let file_endpoint = `file/file/${_image.data.relationships.field_media_image.data.id}`;
				let _file = await fetchAs({ endpoint: file_endpoint, authContext });
				if (_file && _file.data && _file.data.attributes) {
					src = _file.data.attributes.image_style_uri
						? _file.data.attributes.image_style_uri.crop_thumbnail
						: `${generalSettings.data.siteMetaData.drupalUrl}${_file.data.attributes.uri.url}`;
				}
			}
			if (!src) {
				src = `https://${generalSettings.data.siteMetaData.cloudflareClient}.cloudflarestream.com/${cloudflare}/thumbnails/thumbnail.jpg`;
			}
			const format = src.split(".").pop();

			image.format = format;
			image.src = src;
			image.href = src;
			return image;
		} else {
			let video_url;

			let is_video =
				_image.data.type === "media--video" || _image.data.type === "media--remote_video";

			if (_image.data.attributes && _image.data.attributes.field_media_oembed_video) {
				video_url = _image.data.attributes.field_media_oembed_video;
			} else {
				let video_file_rel = Object.entries(_image.data.relationships).find(
					([rel_key, rel_data]) => {
						return (
							rel_data &&
							rel_data.data &&
							rel_data.data.type === "file--file" &&
							rel_key.includes("video")
						);
					}
				);
				if (video_file_rel) {
					let _video_file_endpoint = `file/file/${video_file_rel[1].data.id}`;
					let _video_file = await fetchAs({
						endpoint: _video_file_endpoint,
						authContext,
					});
					if (
						_video_file &&
						_video_file.data &&
						_video_file.data.attributes &&
						_video_file.data.attributes.uri &&
						_video_file.data.attributes.uri.url
					) {
						video_url =
							generalSettings.data.siteMetaData.drupalUrl +
							_video_file.data.attributes.uri.url;
					}
				}
			}

			for (const [rel_key, rel_data] of Object.entries(_image.data.relationships)) {
				if (
					rel_data.data &&
					rel_data.data.type === "file--file" &&
					((is_video && rel_key === "thumbnail") ||
						(!is_video && rel_key !== "thumbnail"))
				) {
					let _file_endpoint = `file/file/${rel_data.data.id}`;
					let _file = await fetchAs({ endpoint: _file_endpoint, authContext });
					if (_file && _file.data && _file.data.attributes) {
						let full_file = { ...rel_data.data, ..._file.data };
						_image.data.relationships[rel_key].data = full_file;
						let image = findImage(_image.data, _image.data.type);
						if (image) {
							if (video_url) image.video = video_url;
							return image;
						}
					}
				}
			}
		}
	}
	return null;
};
